import { Suspense } from "react";
import { axiosSafePromise } from "../api/axiosSafePromise";
import { apiAccountStatusGet } from "../api/account/status/get";

const fetchData = axiosSafePromise(apiAccountStatusGet());
export const StatusPage = () => {
  const authorize = fetchData();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div>{authorize?.status}</div>
    </Suspense>
  )
}
